import { KDrawer } from '@/ui-library/components';
import { Avatar, Button, Icon, UseDisclosureReturn } from '@chakra-ui/react';
import { Edit05 } from '@kula-ai/icons/outline/Edit05';
import { useState } from 'react';
import { InterviewType, ScorecardType } from '../../types/interview';
import { InterviewScorecardForm } from '../InterviewScorecardForm';
import { InterviewScorecardReadOnly } from '../InterviewScorecardReadonly';

interface ViewScorecardDrawerProps {
  viewScorecardActions: UseDisclosureReturn;
  currScorecard: ScorecardType;
  canEditScorecard: boolean;
  interview: InterviewType;
  refetch: () => void;
}

export const ViewScorecardDrawer = ({
  viewScorecardActions,
  currScorecard,
  canEditScorecard,
  interview,
  refetch,
}: ViewScorecardDrawerProps) => {
  const [scEdit, setScEdit] = useState<boolean>(false);

  return (
    <KDrawer
      isOpen={viewScorecardActions.isOpen}
      onClose={viewScorecardActions.onClose}
      KDrawerHeaderProps={{
        leftItems: (
          <Avatar
            width="20px"
            height="20px"
            borderRadius="xs"
            src={currScorecard?.reviewer?.avatar}
            name={currScorecard?.reviewer?.name}
            className="avatar-sm"
          />
        ),
        title: `${currScorecard?.reviewer?.name}'s Scorecard`,
        titleProps: { color: 'secondary-900' },
        rightItems: canEditScorecard && !scEdit && (
          <Button
            variant="secondary"
            size="sm"
            onClick={() => {
              setScEdit(true);
            }}
            leftIcon={<Icon as={Edit05} />}
          >
            Edit scorecard
          </Button>
        ),
      }}
      contentProps={{
        maxW: '650px',
        right: 0,
        position: 'fixed',
        top: 0,
        height: '100vh',
        p: 0,
        borderTopLeftRadius: 'xl',
      }}
      showCloseButton
      skipFooter
      bodyProps={{
        p: scEdit ? '0px' : '16px 24px',
      }}
    >
      {scEdit ? (
        <InterviewScorecardForm
          scorecard={currScorecard}
          interview={interview}
          onSuccess={() => {
            refetch();
            viewScorecardActions.onClose();
          }}
          formContainerStyles={{
            p: '20px 24px',
          }}
        />
      ) : (
        <InterviewScorecardReadOnly scoreCard={currScorecard} />
      )}
    </KDrawer>
  );
};
